
import { setMessageResponse, toggleLoadingIndicator } from "../system/actions";
import { AppThunk } from "../thunks";
import { MessageResponse } from "../system/types";
import { serverMessages } from "../serverMessages";
import { openNotification } from "../../globals/Components/Notification/Notificaction";
import validateMessages from "../../globals/Inputs/validateMessages";
import { TransformationOrganizationSource, TransformationSource } from "src/store/transformationfactors/types";
import { getAllTransformationAPI,GetTransformationByIdAPI,postRegisterTransformationAPI,putUpdateTransformationAPI,
    getTransformationFactorsUnitByEmissionorganizationIdAPI,GetTransformationByFilterFlowAPI,
    getTransformationFactorsUnitByFlowAndSourceAPI,getTransformationFactorsUnitByEmissionIdAPI, getTransformationFactorsUnitByEmissionSourceIdAPI
    } from "src/services/restcall";


    export const getTransformationFactorsUnitByFlowAndSource = (value:string,source:string): AppThunk => async (dispatch) => {
        dispatch(toggleLoadingIndicator(true));
        dispatch(setMessageResponse(null));
        const responseData = await getTransformationFactorsUnitByFlowAndSourceAPI(value,source);
        if (responseData.Error !== null) {
            let message: MessageResponse;
            message = serverMessages(responseData);       
            dispatch(setMessageResponse(message));  
        }
        else if (responseData.StatusCode === 200) {           
            dispatch(setMessageResponse(null));
            dispatch(toggleLoadingIndicator(false));       
            return responseData.Response;
        }
        dispatch(toggleLoadingIndicator(false));
    };
    export const getTransformationFactorsUnitByEmissionorganizationId = (value:string,emissionId:string): AppThunk => async (dispatch) => {
        dispatch(toggleLoadingIndicator(true));
        dispatch(setMessageResponse(null));
        const responseData = await getTransformationFactorsUnitByEmissionorganizationIdAPI(value,emissionId);
        if (responseData.Error !== null) {
            let message: MessageResponse;
            message = serverMessages(responseData);       
            openNotification("Advertencia",message.message[0]);   
        }
        else if (responseData.StatusCode === 200) {           
            dispatch(setMessageResponse(null));
            dispatch(toggleLoadingIndicator(false));       
            return responseData.Response;
        }
        dispatch(toggleLoadingIndicator(false));
    };

    export const getTransformationFactorsUnitByEmissionSourceId = (emissionId:string): AppThunk => async (dispatch) => {
        dispatch(toggleLoadingIndicator(true));
        dispatch(setMessageResponse(null));
        const responseData = await getTransformationFactorsUnitByEmissionSourceIdAPI(emissionId);
        if (responseData.Error !== null) {
            let message: MessageResponse;
            message = serverMessages(responseData);       
            openNotification("Advertencia",message.message[0]);   
        }
        else if (responseData.StatusCode === 200) {           
            dispatch(setMessageResponse(null));
            dispatch(toggleLoadingIndicator(false));       
            return responseData.Response;
        }
        dispatch(toggleLoadingIndicator(false));
    };

    export const getTransformationFactorsUnitByEmissionId = (value:string,emissionId:string): AppThunk => async (dispatch) => {
        dispatch(toggleLoadingIndicator(true));
        dispatch(setMessageResponse(null));
        const responseData = await getTransformationFactorsUnitByEmissionIdAPI(value,emissionId);
        if (responseData.Error !== null) {
            let message: MessageResponse;
            message = serverMessages(responseData);       
            openNotification("Advertencia",message.message[0]);   
        }
        else if (responseData.StatusCode === 200) {           
            dispatch(setMessageResponse(null));
            dispatch(toggleLoadingIndicator(false));       
            return responseData.Response;
        }
        dispatch(toggleLoadingIndicator(false));
    };


export const getAllTransformation = (): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllTransformationAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const GetTransformationById = (value:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await GetTransformationByIdAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const GetTransformationByFilterFlow = (value:string): AppThunk => async (dispatch) => {   
    const responseData = await GetTransformationByFilterFlowAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};





export const postRegisterTransformation = (value:TransformationSource): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));

    const responseData = await postRegisterTransformationAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);     
        openNotification("Advertencia",message.message[0]);   
    }
    else if (responseData.StatusCode === 200) {
   
        openNotification("Ingreso","Transformación "+validateMessages.registerSuccess);  
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putUpdateTransformation = (value:TransformationSource): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));  
    const responseData = await putUpdateTransformationAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        openNotification("Advertencia",message.message[0]);       
        
    }
    else if (responseData.StatusCode === 200) {        
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Transformación "+ validateMessages.updateSuccess);    
        dispatch(toggleLoadingIndicator(false));     
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
